import { FormikHelpers } from 'formik';

export const formSubmission = <T>(submitForm: any) =>
  (values: T, formikBag: FormikHelpers<T>) => {
    formikBag.setSubmitting(true);
    submitForm(values, () => {
      formikBag.setSubmitting(false);
    })
  }